import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

const SIZES = {
  xs: 'h5',
  s: 'h4',
  m: 'h3', // Papa bless
  l: 'h2',
  xl: 'h1',
};

const Heading = ({ size, children, className, tag = SIZES[size], color, isInline }) => {
  const classes = classNames(className, {
    [styles.heading]: true,
    [styles[size]]: true,
    [styles[color]]: true,
    [styles.inline]: isInline,
  });

  const HeadingTag = tag;
  return <HeadingTag className={classes}>{children}</HeadingTag>;
};

Heading.propTypes = {
  size: PropTypes.oneOf(Object.keys(SIZES)),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(['black', 'white']),
  tag: PropTypes.string,
  isInline: PropTypes.bool,
};

Heading.defaultProps = {
  size: 'm',
  className: '',
  tag: undefined, // True default is provided in arugment signature
  color: 'black',
  isInline: false,
};

export default Heading;
